import React from 'react'
import PropTypes from 'prop-types'
import { majorScale, Pane, Spinner } from 'evergreen-v4'

class LoadingPlaceholder extends React.Component {
  static propTypes = {
    /** Whether or not to show the loading placeholder or the children */
    isLoading: PropTypes.bool,
    /** Whether or not to apply default padding */
    noPadding: PropTypes.bool
  }

  static defaultProps = {
    isLoading: false,
    noPadding: false
  }

  render() {
    const { children = null, isLoading, noPadding, ...props } = this.props
    const size = majorScale(3)

    if (isLoading) {
      return (
        <Pane
          display="flex"
          minHeight={size}
          paddingY={noPadding ? 0 : majorScale(8)}
          marginX="auto"
          {...props}
        >
          <Spinner size={size} flexBasis={size} marginX="auto" />
        </Pane>
      )
    }

    return children
  }
}

export default LoadingPlaceholder
